// extracted by mini-css-extract-plugin
module.exports = {"container":"error-boundary_container__zTxAF"};